import React from 'react';
import { Link } from '@tanstack/react-router';
import { useQueryTable } from '@/hooks/useQueryTable';
import { BuslineSchedulesData } from '@area-restrita/api-client/model/buslineSchedulesData';
import { getGetBuslineSchedulesQueryOptions } from '@area-restrita/api-client/endpoints/busline-schedules/busline-schedules.gen';

import { buslineScheduleStatusColumn } from '@/modules/busline-schedules/pages/BuslineSchedules/columns';

import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Table, TableBody } from '@/components/ui/table';
import { DataTableBody } from '@/components/DataTable';
import { Separator } from '@/components/ui/separator';

const FavoriteBusLinesCard: React.FC<{ className?: string }> = ({
  className,
}) => {
  const {
    query: { isLoading },
    table,
  } = useQueryTable<BuslineSchedulesData>({
    columns: [
      buslineScheduleStatusColumn,
      {
        id: 'name',
        header: 'Linha',
        accessorKey: 'name',
        accessorFn: ({ code, name }) => `${code} - ${name}`,
      },
      {
        id: 'startAt',
        header: 'Horário Inicial',
        accessorKey: 'startAt',
      },
      {
        id: 'endAt',
        header: 'Horário Final',
        accessorKey: 'endAt',
      },
    ],
    getQueryOptions: getGetBuslineSchedulesQueryOptions,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 4,
      },
      filters: [
        {
          id: 'favorite',
          value: true,
        },
      ],
    },
  });

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>Linhas de Ônibus Favoritas</CardTitle>
      </CardHeader>
      <CardContent className="px-0 pt-0 pb-6">
        <Table>
          <TableBody>
            <DataTableBody table={table} isLoading={isLoading} />
          </TableBody>
        </Table>
      </CardContent>
      <Separator />
      <CardFooter className="flex gap-4 justify-end pt-6">
        <Link
          className="text-sm underline-offset-4 hover:underline"
          to="/busline-schedules"
        >
          Ver todas as linhas
        </Link>
        <Link
          className="hidden text-sm underline-offset-4 hover:underline"
          to="/documents"
        >
          Ver todas as linhas favoritas
        </Link>
      </CardFooter>
    </Card>
  );
};

export default FavoriteBusLinesCard;
